import { takeLatest, put, select } from 'redux-saga/effects';
import { createAxios, sortSoftsByLocalSoftInit } from '../utils/utils';
import { cacheKeys } from '../constants/storageKeys';
import {
  HOT_SEARCH_URL,
  SEARCH_URL_74,
  SEARCH_RECOMMEND_NEW_61,
  ASSOCIATIVE_WORD_66,
  HOTWORD_APP_LIST_54,
  FEEDBACK_SUGGEST_65,
  HOT_SEARCH_BOX_74,
} from '../config';
import {
  GET_HOT_SEARCH_START,
  GET_HOT_SEARCH_SUCCESS,
  GET_HOT_SEARCH_APP_START,
  GET_HOT_SEARCH_APP_SUCCESS,
  GET_LENOVOWORDS_SEARCH_START,
  GET_LENOVOWORDS_SEARCH_SUCCESS,
  GET_RESULT_SEARCH_SUCCESS,
  GET_RESULT_SEARCH_START,
  GET_SEARCH_RECOMMEND_START,
  GET_SEARCH_RECOMMEND_SUCCESS,
  CLEAN_SEARCH_RECOMMEND_START,
  CLEAN_SEARCH_RECOMMEND_SUCCESS,
  GET_FEEDBACK_SUGGEST,
  SET_FEEDBACK_VISIBLE,
  GET_HOT_SEARCH_BOX,
  SET_HOT_SEARCH_BOX,
} from '../constants/search';
import { PCStoreJsBridge } from '../nativeapi';
import Toast from '../components/Toast/Toast';

function* fetchLenovoWords({ kw }) {
  if (!kw) {
    yield put({
      type: GET_LENOVOWORDS_SEARCH_SUCCESS,
      payload: { data: [], kw },
    });
  }
  try {
    const axios = yield createAxios();
    const res = yield axios.get(ASSOCIATIVE_WORD_66, { params: { word: kw, needSInfo: '1' } });
    if (res.data.status === 0) {
      yield put({
        type: GET_LENOVOWORDS_SEARCH_SUCCESS,
        payload: { ...res.data, kw },
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchSearchResult({ keyword, firstId, androidType }) {
  try {
    yield put({ type: GET_RESULT_SEARCH_SUCCESS, payload: null });

    let vt = localStorage.getItem(cacheKeys.IS_VT_ENABLE);
    if (vt === null) {
      const isVTEnable = yield PCStoreJsBridge.getIsVTEabled();
      vt = isVTEnable.vt ? '1' : '0';
      localStorage.setItem(cacheKeys.IS_VT_ENABLE, vt);
    }

    const axios = yield createAxios();
    const res = yield axios.get(SEARCH_URL_74, {
      params: { softName: keyword, skip: 0, limit: 30, vt, firstId, androidType },
    });
    if (res.data.status === 0) {
      yield put({
        type: GET_RESULT_SEARCH_SUCCESS,
        payload: {
          ...res.data.data,
          params: { softName: keyword, skip: 0, limit: 30, loading: false },
        },
      });
    } else {
      yield put({
        type: GET_RESULT_SEARCH_SUCCESS,
        payload: {
          count: 0,
          params: { softName: keyword, skip: 0, limit: 30, loading: false },
        },
      });
    }
  } catch (error) {
    // throw error;
  }
}

function* fetchSearchRecommend(param) {
  const { softInfo, androidType, source } = param;
  try {
    const installedSoft = (yield select(state => state.native.installedSoft)) || [];
    const axios = yield createAxios();
    const res = yield axios.get(SEARCH_RECOMMEND_NEW_61, {
      params: { softInfo, androidType, source },
    });
    if (res.data.status === 0) {
      const newSearchReco = {};
      const appsFilter = sortSoftsByLocalSoftInit(res.data.data.apps, installedSoft);
      newSearchReco[softInfo] = {
        ...res.data.data,
        apps: appsFilter,
        softInfo,
        androidType,
        source,
      };
      // res.data.data.apps.forEach(item => {
      //   const found = installedSoft.find(soft => soft.softID === item.softID || soft.SoftID === item.softID);
      //   if (found === undefined) {
      //     appsFilter.push(item);
      //   }
      // });
      // newSearchReco[softId] = { ...res.data.data, apps: appsFilter };
      yield put({
        type: GET_SEARCH_RECOMMEND_SUCCESS,
        payload: newSearchReco,
      });
    }
  } catch (error) {
    // throw error;
  }
}
function* fetchCleanSearchRecommend() {
  yield put({
    type: CLEAN_SEARCH_RECOMMEND_SUCCESS,
    payload: {},
  });
}

/**
 * 搜索反馈
 */

function* fetchFeedbackSuggest({ payload }) {
  const axios = yield createAxios();
  const res = yield axios.post(FEEDBACK_SUGGEST_65, {
    ...payload,
  });

  try {
    if (res.data.status === 0) {
      Toast.success({
        content: '提交成功',
        duration: 2.8,
      });
      yield put({
        type: SET_FEEDBACK_VISIBLE,
        payload: {
          feedbackVisible: false,
        },
      });
    }
  } catch (err) {
  } finally {
    if (!res || !res.data || res.data.status !== 0) {
      Toast.error({
        content: '提交失败，请稍后再试!',
        duration: 2.8,
      });
    }
  }
}

function* fetchHotSearchBox() {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(HOT_SEARCH_BOX_74);
    if (res.data.status === 0) {
      yield put({ type: SET_HOT_SEARCH_BOX, payload: res.data.data });
    } else {
      yield put({
        type: SET_HOT_SEARCH_BOX,
        payload: {
          hotWordList: [],
          hotWordAppList: [],
          searchBarWordList: [],
        },
      });
    }
  } catch (error) {
    yield put({
      type: SET_HOT_SEARCH_BOX,
      payload: {
        hotWordList: [],
        hotWordAppList: [],
        searchBarWordList: [],
      },
    });
  }
}

export function* watchFetchLenovoWords() {
  yield takeLatest(GET_LENOVOWORDS_SEARCH_START, fetchLenovoWords);
}
export function* watchFetchSearchResult() {
  yield takeLatest(GET_RESULT_SEARCH_START, fetchSearchResult);
}

export function* watchFetchSearchRecommend() {
  yield takeLatest(GET_SEARCH_RECOMMEND_START, fetchSearchRecommend);
}

export function* watchFetchCleanSearchRecommend() {
  yield takeLatest(CLEAN_SEARCH_RECOMMEND_START, fetchCleanSearchRecommend);
}
export function* watchFetchFeedbackSuggest() {
  yield takeLatest(GET_FEEDBACK_SUGGEST, fetchFeedbackSuggest);
}
export function* watchFetchHotSearchBox() {
  yield takeLatest(GET_HOT_SEARCH_BOX, fetchHotSearchBox);
}
